import { motion, useReducedMotion } from "framer-motion";

const statements = [
  "My time belongs on cases — I want someone else to handle the marketing.",
  "I want ads that actually work this time.",
  "I just want a steady flow of good clients. Something I can trust to run.",
  "I want an agency that truly knows how immigration firms run.",
];

export function SocialProof() {
  const reduced = useReducedMotion();

  return (
    <section id="sound-familiar" className="py-10 md:py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-5 sm:space-y-6">
        <motion.p
          {...(reduced ? {} : { initial: { opacity: 0 }, whileInView: { opacity: 1 } })}
          viewport={{ once: true }}
          className="text-xs md:text-sm uppercase tracking-[0.2em] text-muted-foreground text-center"
        >
          Sound Familiar?
        </motion.p>

        <div className="grid sm:grid-cols-2 gap-3 md:gap-4">
          {statements.map((s, i) => (
            <motion.div
              key={i}
              initial={reduced ? {} : { opacity: 0, y: 16 }}
              whileInView={reduced ? {} : { opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={reduced ? {} : { delay: i * 0.1, duration: 0.5 }}
              className="border-l-4 border-primary rounded-xl p-4 md:p-5 bg-card backdrop-blur-sm"
            >
              <p className="text-sm md:text-base italic leading-relaxed text-foreground/90">
                "{s}"
              </p>
            </motion.div>
          ))}
        </div>

        <div className="w-16 h-px bg-foreground/20 mx-auto" />

        <motion.p
          initial={reduced ? {} : { opacity: 0, y: 12 }}
          whileInView={reduced ? {} : { opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={reduced ? {} : { delay: 0.5 }}
          className="text-2xl md:text-4xl font-bold text-center tracking-tight text-foreground"
        >
          That's exactly why we built FuzionLabs.
        </motion.p>
      </div>
    </section>
  );
}
